"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgVegetarianFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.956 4.527c-.789 4.943-2.094 9.702-4.076 13.067-2.935 4.983-7.043 5.994-11.794 1.717l3.322-3.322h3.583a1 1 0 0 0 0-1.998h-1.584l1.998-1.999h1.585a1 1 0 1 0 0-1.998h-1v-1a1 1 0 0 0-1.998 0v1.585l-1.999 1.999v-1.585a1 1 0 1 0-1.998 0v3.583l-3.322 3.322C.396 13.148 1.407 9.039 6.39 6.104c3.365-1.982 8.128-3.288 13.066-4.075a2.167 2.167 0 0 1 2.5 2.498Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgVegetarianFilled);
//# sourceMappingURL=SvgVegetarianFilled.js.map